import { render, staticRenderFns } from "./GetCoupon.vue?vue&type=template&id=6c89f5b1&scoped=true&"
import script from "./GetCoupon.vue?vue&type=script&lang=js&"
export * from "./GetCoupon.vue?vue&type=script&lang=js&"
import style0 from "./GetCoupon.vue?vue&type=style&index=0&id=6c89f5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89f5b1",
  null
  
)

export default component.exports